import { render, staticRenderFns } from "./Marketing.vue?vue&type=template&id=6870bf6a&scoped=true"
import script from "./Marketing.vue?vue&type=script&lang=js"
export * from "./Marketing.vue?vue&type=script&lang=js"
import style0 from "./Marketing.vue?vue&type=style&index=0&id=6870bf6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6870bf6a",
  null
  
)

export default component.exports